export default () => {
  const form = document.getElementById('student-lesson-form');
  if (!form) return;

  form.addEventListener('submit', (_event) => {
    const clientTimeField = document.getElementById('client_time');
    clientTimeField.value = Date.now();
  });
};
